import { ChakraFlex, ChakraVStack } from '@equip.health/ui';
import { ErrorBoundary } from 'react-error-boundary';
import { PatientCarePlans } from '~/components/maud/patients/profile/tabs/careplan/PatientCarePlans';
import SMTConfigurationCardErrorFallback from '~/components/maud/patients/profile/tabs/careplan/SMTConfigurationCardErrorFallback';
import SMTConfigurationCard from '~/components/maud/patients/profile/tabs/careplan/SMTConfigurationCard';
import { PreviousCarePlans } from '~/components/maud/patients/profile/tabs/careplan/PreviousCarePlans';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { CarePlanErrorFallback } from './CarePlanErrorFallback';

export const CarePlanView = ({ patientId }) => {
  const { enableSelfMonitoringTools: isEnableSelfMonitoringToolsEnabled } =
    useFlags<LDFlags>();
  return (
    <ChakraFlex flexDirection="column">
      <ChakraVStack gap="40px" width="100%">
        <ErrorBoundary fallback={<CarePlanErrorFallback />}>
          <PatientCarePlans patientId={patientId} />
        </ErrorBoundary>
        {isEnableSelfMonitoringToolsEnabled && (
          <ErrorBoundary fallback={<SMTConfigurationCardErrorFallback />}>
            <SMTConfigurationCard patientId={patientId} />
          </ErrorBoundary>
        )}
      </ChakraVStack>
      <PreviousCarePlans patientId={patientId} />
    </ChakraFlex>
  );
};
